import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from "@angular/core";
import { AngularFireStorage, AngularFireUploadTask } from "angularfire2/storage";
import { Platform, ActionSheetController, LoadingController, AlertController } from "ionic-angular";
import { ImageProvider } from "../../providers/image/image";
import { Observable } from 'rxjs/Observable';
import * as mime from 'mime-types';
import { DatabaseProvider } from "../../providers/database/database";
import { PatientProvider } from "../../providers/patient/patient";
import { AuthProvider } from "../../providers/auth/auth";
import { BehaviorSubject, Subject } from "rxjs";

@Component({
  selector: "app-multi-file-upload",
  templateUrl: "multi-file-upload.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiFileUploadComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  private _program_id = new BehaviorSubject<any>([]);
  private _program_name = new BehaviorSubject<any>([]);
  private _patient = new BehaviorSubject<any>([]);

  @Input()
  set programId(value) { this._program_id.next(value); }
  get programId() { return this._program_id.getValue(); }

  @Input()
  set programName(value) { this._program_name.next(value); }
  get programName() { return this._program_name.getValue(); }

  @Input()
  set patientData(value) { this._patient.next(value); }
  get patientData() { return this._patient.getValue(); }

  @Output() getUrl = new EventEmitter<Object>();

  task: AngularFireUploadTask;
  program_id: string;
  program_name: string;
  patient: any;
  progress: any; // Observable 0 to 100
  complete: any;
  ismobile: boolean;
  imageUrl: string; // base64
  pdfUrl: string;
  downloadUrl: string;
  image_type: string = 'prescription';
  user: any;

  snapshot: Observable<any>;
  isHovering: boolean;

  public mobileimages = [];

  constructor(
    public storage: AngularFireStorage,
    private image: ImageProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
    private auth: AuthProvider,
    private dbPatient: PatientProvider
  ) {}

  ngOnInit() {
    this._program_id
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.program_id = x
    });

    this._program_name
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.program_name = x
    });

    this._patient
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.patient = x
    });
    this.auth.getCurrentUser().then(user => {
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
    });
  }

  ngOnDestroy() {
    console.log('Destroying multi-file upload component');
    this._patient.unsubscribe();
    this._program_id.unsubscribe();
    this._program_name.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  async createUploadTask(file: any) {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      filePath = `documents/${new Date().getTime()}_${file.name}.${file.ext}`;
      this.task = this.storage.ref(filePath).putString(file['b64'], "data_url")
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          file['url'] = u;
          file['type'] = 'NA'
          this.getUrl.emit(file);
          console.log("File Upload Complete: ", this.patient, file); 
          const patient = {
            id: this.patient.id,
            first_name: this.patient.first_name,
            last_name: this.patient.last_name,
            program_patient_id: this.patient.program_patient_id
          }
          this.dbPatient.addDocument(this.program_id, patient, file, this.user);
          this.cd.markForCheck();
          resolve(true);
        })
      });
      this.snapshot   = this.task.snapshotChanges();
      this.progress = this.task.percentageChanges();
    });
  }

  public uploadDesktopFiles(files: FileList) {
    const loading = this.loadingCtrl.create({});
    loading.present();

    this.processFiles(Array.from(files)).then((uploads) => {
      setTimeout(() => {
        const start = async () => {
          await this.asyncForEach(uploads, async (file) => {
            await this.createUploadTask(file);
          });
          loading.dismiss();
        }
        start();
      }, 500);
    });
  }

  async processFiles(files) {
    let i = [];
    await files.reduce(async (promise, file) => {
      await promise;
      this.image.getBase64(file).then((image) => {
        let filename = file.name;
        let name: any = file.name.split('.')[0].replace(' ','');
        let fileext: any = file.name.split('.')[1].replace(' ','');
        let mimetype: any = mime.lookup(fileext);
        i.push({ filename: filename, name: name, b64: image, ext: fileext, mimetype: mimetype });
      });
    }, Promise.resolve());
    return i;
  }

    // Determines if the upload task is active
    isActive(snapshot) {
      return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
    }

    toggleHover(event: boolean) {
      this.isHovering = event;
    }

  deleteImage(image)  {
    let index = this.mobileimages.indexOf(image);
    if (index > -1) {
      this.mobileimages.splice(index, 1);
    }
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/multi-file-upload/multi-file-upload.ts